import React from "react";
import { ModalBuilder, SignalR } from "@redriver/cinnamon";
import { useTranslation } from "react-i18next";
import { TranslatedModal } from "features/../../../shared/components/modals";

const SettingsEditedCallbackModal = ({ onSubmit }) => {
  const { t } = useTranslation("sheetTranslation", {
    keyPrefix: "UpdateNotificationModal",
  });
  const [showModal, setShowModal] = React.useState(false);
  return (
    <React.Fragment>
      <SignalR.Callback
        methodName="SettingsEdited"
        callback={() => {
          setShowModal(true);
        }}
      />
      <ModalBuilder
        visible={showModal}
        onSubmit={() => {
          setShowModal(false);
          onSubmit();
        }}
        renderModal={(modalProps, formProps) => (
          <TranslatedModal.Confirmation
            {...modalProps}
            header={t("Header")}
            onClose={() => setShowModal(false)}
          >
            {t("ConfirmMessage")}
          </TranslatedModal.Confirmation>
        )}
      />
    </React.Fragment>
  );
};

export default SettingsEditedCallbackModal;
